/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';
import genericReducers from '../genericReducer';
import { IReducers } from '../index';

import { GET_CULTURAL_KINDS } from '../../actions/employees';
import { REQUEST, FAILURE, SUCCESS } from '../../actions/utils';

import { ICommonResponse, ICulturalKind } from '../../api/types';

export type CulturalKindState = ICommonResponse<ICulturalKind>;

const initialState = {} as ICommonResponse<ICulturalKind>;
const generic = genericReducers<CulturalKindState>();
const culturalKinds: IReducers<CulturalKindState> = {
  [GET_CULTURAL_KINDS[REQUEST]]: generic.get.request,
  [GET_CULTURAL_KINDS[SUCCESS]]: generic.get.success,
  [GET_CULTURAL_KINDS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, culturalKinds);
